'use client'

import { useState } from 'react'

import { useFeatureSwitch } from '@marketplace-web/shared/feature-switches'

import RoktAdvertisement from '../RoktAdvertisement'
import VanOfferAdvertisement from '../VanOfferAdvertisement'

const OfferAdvertisement = () => {
  const [isRoktPrioritezed, setIsRoktPrioritezed] = useState(true)
  const isOfferAdvertisementEnabled = useFeatureSwitch('web_offer_advertisement')

  const onRoktDeprioritization = () => setIsRoktPrioritezed(false)

  if (!isOfferAdvertisementEnabled)
    return <RoktAdvertisement onDeprioritization={onRoktDeprioritization} />

  return isRoktPrioritezed ? (
    <RoktAdvertisement onDeprioritization={onRoktDeprioritization} />
  ) : (
    <VanOfferAdvertisement />
  )
}

export default OfferAdvertisement
